// 🇨🇳 V120 중국 모드(jjggfood.com) — Firebase가 첫 요청을 보내기 전에 주소를 바꿔 끼워야 하므로 맨 먼저
import './chinaMode';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './appCheck';  // 🛡️ Firebase App Check — Firebase 초기화 직후 활성화
import App from './App';
import UpdateBanner from './components/UpdateBanner';   // V145 새 버전 새로고침 버튼
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <UpdateBanner />
  </React.StrictMode>
);

// PWA — 오프라인 지원 + 홈 화면 추가
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
